export default __webpack_public_path__ + "static/media/ts.58913302.png";